import { Events } from '../../utils/servicesEvents'
import { Formatter } from './formatter'
import { TransactionRepo } from './repo'
import { launchTransaction } from './networks/launchTransaction'
import { downloadUserTransactions } from './networks/downloadUserTransactions'

class TransactionController {
  static async downloadData() {
    downloadUserTransactions(
      'transactions_downloaded',
      'failed_to_download_transactions',
    )
  }

  static async initListeners() {
    Events.handleEvent('transactions_downloaded', async ({ data }) => {
      const db = await TransactionRepo.getDb()
      await db.save(data)
      Events.dispatchEvent('transactions_updated')
    })

    Events.handleEvent('launch_transaction_request', async data => {
      launchTransaction(
        data,
        'transaction_launched',
        'failed_to_launch_transaction',
      )
    })

    Events.handleEvent('launch_vip_subscription', async data => {
      launchTransaction(
        data,
        'vip_subscription_launched',
        'failed_to_launch_vip_subscription',
      )
    })

    Events.handleEvent(
      'request:transaction',
      async ({ responseId, reference }) => {
        const db = await TransactionRepo.getDb()
        let transactions = await db.findOne(reference)
        Events.dispatchEvent(responseId, transactions)
      },
    )

    Events.handleEvent('request:transactions', async ({ responseId }) => {
      const db = await TransactionRepo.getDb()
      const transactions = await db.get()
      Events.dispatchEvent(responseId, transactions)
      // TransactionController.downloadData()
    })

    Events.handleEvent('clean_all_data_requested', () => {
      TransactionRepo.getDb().then(async db => {
        await db.clean()
        Events.dispatchEvent('transactions_updated')
      })
    })

    Events.handleEvent('transaction_url_notif_available', async data => {
      const content = data?.metaData?.content
      Events.dispatchEvent('transaction_url_available', {
        url: content.url,
        id: content.transactionId,
      })
    })

    Events.handleEvent('collection_finished_notif_available', async data => {
      const content = data?.metaData?.content
      Events.dispatchEvent('collection_finished_available', {
        id: content.transactionId,
        status: content.status,
      })
    })
  }
}

export { TransactionController }
